import { NavigationLinks } from '../types/NavigationLinks';

export const convertNavigationLinksToArrays = (nav: NavigationLinks) => {
  const { mainNavigation } = nav;
  const mainLinks = Object.entries(mainNavigation)
    .filter(([, menuItem]) => menuItem.show === 'true')
    .map(([menuKey, menuItem]) => ({
      ...menuItem,
      columns: Object.entries(menuItem.columns)
        .filter(([, column]) => column.show === 'true'
            && Object.entries(column.columnLinks).filter(([, item]) => item.show === 'true').length > 0)
        .map(([columnKey, column]) => ({
          ...column,
          columnLinks: Object.entries(column.columnLinks)
            .filter(([, link]) => link.show === 'true')
            .map(([linkKey, link]) => ({
              ...link,
              key: linkKey,
            })),
          key: columnKey,
        })),
      key: menuKey,
    }));
  const { profileDrawer } = nav;
  const profileLinks = Object.values(profileDrawer)
    .filter((menuItem) => menuItem.show === 'true')
    .map((menuItem) => menuItem);
  return {
    ...nav,
    mainNavigation: mainLinks,
    profileDrawer: profileLinks,
  };
};
